import styled from "styled-components";
import gpt_300_online from "./gpt_300_online.webp";

const Img = styled.img`
  width: 237px;
  height: 152px;

  border-radius: 8px;
`;

export default () => <Img src={gpt_300_online} alt={"chatgpt_300%_활용하기"} />;
